import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

import AuthModule from "./modules/auth"
import ReportsModule from "./modules/reports"
import StatisticsModule from "./modules/statistics"

Vue.use(Vuex)

let state = {
  loader: false
}

export default function (config) {
  return new Vuex.Store({
    state: Object.assign({}, state, config),
    mutations,
    getters,
    actions,
    modules: {
      auth: AuthModule(),
      reports: ReportsModule(),
      statistics: StatisticsModule(),
    }
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js